import { Component, inject, input } from '@angular/core';

import { BrandingService } from './branding.service.js';

/**
 * Renders the active brand logo, swapping automatically between the light
 * and dark variants based on ThemeService. Use everywhere the
 * EchoSpaces logo was hardcoded — customer deployments get the right
 * asset for free.
 */
@Component({
  selector: 'es-brand-logo',
  template: `<img [src]="branding.logoUrl()" [alt]="alt() ?? branding.name() + ' logo'" />`,
})
export class BrandLogoComponent {
  readonly branding = inject(BrandingService);

  /** Override the default alt text (`"{name} logo"`). */
  readonly alt = input<string | null>(null);
}
